import { mapEnumToOptions } from '@abp/ng.core';

export enum PeriodState {
  Inactive = 0,
  Active = 1,
}

export const periodStateOptions = mapEnumToOptions(PeriodState);
